import { getAccount, getCurrency, getGameSlug, getToken } from './axios'
import BaseService from './base.service'

const API_URL = process.env.VUE_APP_API_URL

class GamesService extends BaseService {
    async getAllSetting(lang: string) {
        const [settings, locale] = await Promise.all([this.accountSettings(), this.getLocale(lang)])

        return { settings, locale }
    }

    accountSettings() {
        const account = getAccount()
        const currency = getCurrency()
        return this.get(`${API_URL}/api/account-settings?account=${account}&currency=${currency}`).then(
            ({ data }) => data
        )
    }

    getLocale(lang) {
        const account = getAccount()
        return this.get(`${API_URL}/api/locale?account=${account}&lang=${lang}`).then(({ data }) => data)
    }

    getListGames() {
        const account = getAccount()
        return this.get(`${API_URL}/api/game-settings?account=${account}`).then(({ data }) => data)
    }

    transactionBet(bets: any) {
        let account_slug = getAccount()
        let currency = getCurrency()
        let game_slug = getGameSlug()
        let token = getToken() || ''

        let param = {
            bets,
            currency,
            game_slug,
            account_slug,
            token,
        }

        return this.post(`${API_URL}/api/transaction/bet`, param).then(({ data }) => data)
    }

    getListHistory(current_page: string, limit: string, keyword: string = '', selectedStatus: string) {
        let account_slug = getAccount()
        let currency = getCurrency()
        let game_slug = getGameSlug()
        let token = getToken()

        let param = {
            currency,
            game_slug,
            account_slug,
            token,
            current_page,
            limit,
            keyword,
            status: selectedStatus,
        }

        return this.post(`${API_URL}/api/transaction/history`, param).then(({ data }) => data)
    }

    getStatusHistory() {
        const account = getAccount()
        return this.get(`${API_URL}/api/transaction/status?account=${account}`).then(({ data }) => data)
    }
}

export default new GamesService()
